<div
  class="teaser"
  [attr.data-type]="type"
  [ngClass]="{
    'image-border': border,
    reverse: reverse,
    'color-gradation-success':
      background === BgColors.GREEN && type !== TeaserType.SMALL,
    'color-neutral-lightest': background === BgColors.NEUTRAL_LIGHTEST,
    'color-neutral-lighter':
      background === BgColors.NEUTRAL_LIGHTER && type !== TeaserType.SMALL,
    'teaser-hidden': isHidden,
    'teaser--full-width': columns === 1,
  }"
  [attr.data-viewport]="viewport"
  [attr.data-media-type]="mediaType"
  [attr.disabled]="disabled"
  (click)="
    type === TeaserType.HUB || type === TeaserType.LANDSCAPE
      ? handleTeaserClick()
      : null
  "
  #teaser
>
  <ng-container *ngIf="mediaType === 'image' && type !== 'stage'">
    <div
      class="teaser__image"
      *ngIf="type !== 'simple'"
      [ngClass]="{ 'image-border': imageBorder, reverse: reverse }"
      [ngStyle]="{ height: imageHeight }"
    >
      <hdi-image
        [src]="imageSrc!"
        [alt]="imageAlt!"
        [title]="imageTitle"
        [viewport]="viewport"
      ></hdi-image>
    </div>
  </ng-container>
  <ng-container
    *ngIf="
      mediaType === 'icon' &&
      (type === 'stage' ||
        type === 'small' ||
        type === 'tools' ||
        type === 'medium' ||
        type === 'landscape')
    "
  >
    <div class="teaser__icon" *ngIf="iconType">
      <hdi-icon
        [iconName]="iconType"
        [size]="iconSize!"
        [color]="iconColor"
      ></hdi-icon>
    </div>
  </ng-container>

  <div class="teaser__content" [ngStyle]="{ padding: !isPadding && '0' }">
    <ng-container>
      <div
        *ngIf="date || (badges && badges.length > 0)"
        class="teaser__badges-wrapper"
      >
        <div class="teaser__badges" *ngIf="badges && badges.length > 0">
          <hdi-badge
            *ngFor="let badge of badges"
            [type]="badge.type"
            [label]="badge.label"
            [size]="badgeSize"
            [viewport]="viewport"
          ></hdi-badge>
          <span
            class="copy-s"
            *ngIf="badgeSubline"
            [innerHTML]="badgeSubline"
          ></span>
        </div>
        <span class="date" *ngIf="date">{{ date }}</span>
      </div>
    </ng-container>
    <ng-container *ngIf="headlineSize">
      <ng-container [ngSwitch]="headlineSize">
        <h1
          *ngSwitchCase="Headlines.H1"
          class="headline"
          [innerHTML]="headline"
          [attr.data-viewport]="viewport"
        ></h1>
        <h2
          *ngSwitchCase="Headlines.H2"
          class="headline"
          [innerHTML]="headline"
          [attr.data-viewport]="viewport"
        ></h2>
        <h3
          *ngSwitchCase="Headlines.H3"
          class="headline"
          [innerHTML]="headline"
          [attr.data-viewport]="viewport"
        ></h3>
        <h4
          *ngSwitchCase="Headlines.H4"
          class="headline"
          [innerHTML]="headline"
          [attr.data-viewport]="viewport"
        ></h4>
        <h5
          *ngSwitchCase="Headlines.H5"
          class="headline"
          [innerHTML]="headline"
          [attr.data-viewport]="viewport"
        ></h5>
        <h6
          *ngSwitchCase="Headlines.H6"
          class="headline"
          [innerHTML]="headline"
          [attr.data-viewport]="viewport"
        ></h6>
      </ng-container>
    </ng-container>
    <p
      class="text"
      [ngClass]="{
        'text--no-badges': badges && badges.length === 0,
        'text--no-cta': CTA !== ActionType.LINK || !label,
      }"
      *ngIf="description"
      [innerHTML]="description"
    ></p>
    <hdi-link
      *ngIf="CTA === ActionType.LINK && label"
      [label]="label | capitalize"
      [type]="linkType!"
      [target]="target!"
      [hrefType]="hrefType"
      [href]="href ?? ''"
      [fragment]="fragment"
      [title]="title"
      [target]="target || '_self'"
      [viewport]="viewport"
      [video]="video"
      [disabled]="disabled"
      #hdiLink
      (click)="type === TeaserType.HUB ? $event.stopPropagation() : null"
      (clickEvent)="handleLinkClick()"
    ></hdi-link>
  </div>
</div>
